import { render, staticRenderFns } from "./ListCompare.vue?vue&type=template&id=23f68eb0&scoped=true"
import script from "./ListCompare.vue?vue&type=script&lang=js"
export * from "./ListCompare.vue?vue&type=script&lang=js"
import style0 from "./ListCompare.vue?vue&type=style&index=0&id=23f68eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f68eb0",
  null
  
)

export default component.exports